import React from 'react';
import { ManageOptionsProvider } from './components/ManageOptionsProvider';
import { ManageOptionsContainer } from './components/ManageOptionsContainer';

export const ManageTeachingOrder = () => {
  return (
    <ManageOptionsProvider>
      <ManageOptionsContainer />
    </ManageOptionsProvider>
  );
};
